// src/routes/PageDetails.jsx
import { useParams } from "react-router-dom";

import PageRenderer from "./PageRender";
import MenuService from "../../services/MenuService";
import { useQuery } from "@tanstack/react-query";
import PageService from "../../services/PageService";

const PageDetails = () => {
  const { slug } = useParams();
  console.log("🚀 ~ PageDetails ~ slug:", slug)

  const { isLoading, error, data } = useQuery({
    queryKey: ["page-list"],
    queryFn: PageService.getList,
  });
  console.log("🚀 ~ PageDetails ~ data:", data)

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading page</div>;

  //   FIND PAGE BY SLUG
  const page = data?.items?.find((item) => item.slug === slug);

  if (!page) return <div>Page not found</div>;

  return <PageRenderer pageData={page} />;
};

export default PageDetails;